import { createTheme } from '@mantine/core';

export const theme = createTheme({
  fontFamily: 'Inter, sans-serif',
  colors: {
    // Define your color palette here
  },
  components: {
    Button: {
      styles: {
        root: {
          fontFamily: 'Inter, sans-serif',
          color: '#303030',
        },
      },
    },
    Text: {
      styles: {
        root: {
          fontFamily: 'Inter, sans-serif',
          color: '#303030',
        },
      },
    },
    // Add other component overrides as needed
  },
}); 